import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { DynamicDirective } from './dynamic/dynamic.directive';

@NgModule({ declarations: [
        DynamicDirective
    ],
    exports: [
        DynamicDirective
    ],
    imports: [CommonModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())]
})
export class CoreModule { }

export * from './dynamic/registry';
export * from './dynamic/dynamic.component';
export * from './dynamic/dynamic.directive';
export * from './component/secure.component';
export * from './component/attribute.component';
export * from './component/node-view.component';
export * from './component/tree.component';
export * from './component/node.component';
export * from './component/panel.component';
export * from './component/content-base.component';
